import { AppLayout } from '@src/components/sco/AppLayout';
import { useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext';
import { AppLayoutPanelProps } from '@src/components/sco/AppLayout/Panel';
import { InvestorSearchAside } from '@src/components/sco/InvestorSearch/Layout/InvestorSearchAside';
import { InvestorSearchContextProvider } from '@src/components/sco/InvestorSearch/Layout/InvestorSearchContext';
import { InvestorSearchNav } from '@src/components/sco/InvestorSearch/Layout/InvestorSearchNav';
import { ScoSiteNavBar } from '@src/components/sco/nav/ScoSiteNavBar';
import { useAppContextStore } from '@src/contexts/AppContextStore';
import { usePathname } from 'next/navigation';
import { parseAsString, useQueryState } from 'nuqs';
import React, { useEffect, useMemo } from 'react';
type InvestorSearchLayoutProps = {
  asidePanel?: React.ReactNode;
  mainPanel?: React.ReactNode;
  navPanel?: React.ReactNode;
};
export const InvestorSearchLayout: React.FC<InvestorSearchLayoutProps> = props => {
  const pathname = usePathname();
  const {
    contextStore
  } = useAppContextStore();
  const [investorProfileId] = useQueryState('investorProfileId', parseAsString);
  const [asidePanelIsOpen, setAsidePanelIsOpen] = React.useState(false);
  const layout = useParentAppLayout();
  const panels: AppLayoutPanelProps[] = useMemo(() => [{
    id: 'investor-search-nav',
    useDrawerBreakpoints: {
      base: true,
      md: false
    },
    isResizable: true,
    resizeHandlePosition: 'right',
    defaultWidth: 280,
    minWidth: 200,
    maxWidth: 400,
    children: props.navPanel ? props.navPanel : <InvestorSearchNav />,
    isPanelOpen: true,
    isDrawerOpen: false,
    containerProps: {
      bgColor: 'colorPalette.bg'
    }
  }, {
    id: 'investor-search-main',
    children: props.mainPanel,
    isPanelOpen: true,
    isDrawerOpen: true,
    containerProps: {
      bgColor: 'colorPalette.container',
      borderRadius: 'lg',
      boxShadow: 'sm'
    }
  }, {
    id: 'investor-search-aside',
    useDrawerBreakpoints: {
      base: true,
      md: false
    },
    isResizable: true,
    resizeHandlePosition: 'left',
    drawerPlacement: 'right',
    defaultWidth: 480,
    minWidth: 300,
    maxWidth: 600,
    children: investorProfileId && <InvestorSearchAside investorProfileId={investorProfileId} />,
    isPanelOpen: !!investorProfileId,
    isDrawerOpen: !!investorProfileId,
    onPanelClose: () => {
      setAsidePanelIsOpen(false);
    },
    containerProps: {
      bgColor: 'colorPalette.panel',
      borderRadius: 'lg',
      boxShadow: 'sm'
    }
  }], [pathname, investorProfileId]);
  useEffect(() => {
    if (investorProfileId) {
      setAsidePanelIsOpen(true);
    } else {
      setAsidePanelIsOpen(false);
    }
  }, [investorProfileId]);
  return <InvestorSearchContextProvider {...contextStore.getNamespace('InvestorSearchContext')}>
      <AppLayout header={<ScoSiteNavBar />} id={'InvestorSearch-layout'} panels={panels} />
    </InvestorSearchContextProvider>;
};